import HttpClient from '../util/http/HttpClient'
import HttpClientAxios from '../util/http/HttpClientAxios'

export interface NacelleEventsParams {
  endpoint?: string
  httpClient?: HttpClient
  disable?: boolean
}

export interface EventSubscription {
  eventType: string
  callback: (event: EventObject) => EventObject | null
}

export interface EventObject {
  eventType: string
  spaceID?: string
  [key: string]: any
}

export default class NacelleEvents {
  endpoint: string
  apiClient: HttpClient
  disable: boolean
  subscriptions: EventSubscription[]

  constructor(params?: NacelleEventsParams) {
    if (params && params.endpoint && params.endpoint.length > 0) {
      this.endpoint = params.endpoint
    } else if (
      process &&
      process.env &&
      process.env.NACELLE_TEM_ENDPOINT &&
      process.env.NACELLE_TEM_ENDPOINT.length > 0
    ) {
      this.endpoint = process.env.NACELLE_TEM_ENDPOINT
    } else {
      // Set default TEM endpoint
      this.endpoint =
        'https://fu4vd9aay2.execute-api.us-east-1.amazonaws.com/dev/events/add'
    }

    this.apiClient =
      params && params.httpClient ? params.httpClient : new HttpClientAxios()

    if (params && typeof params.disable !== 'undefined') {
      this.disable = params.disable
    } else {
      this.disable = false
    }

    this.subscriptions = []
  }

  log(event: EventObject): void {
    let eventToSend = event

    if (!this.disable) {
      this.subscriptions
        .filter(({ eventType }) => event.eventType === eventType)
        .forEach(({ callback }) => {
          if (callback) {
            const modifiedEvent = callback(event)

            if (modifiedEvent) {
              eventToSend = {
                ...eventToSend,
                ...modifiedEvent
              }
            }
          }
        })

      this.apiClient.post(this.endpoint, event)
    }
  }

  onEvent(
    eventType: string,
    callback: (event: EventObject) => EventObject
  ): void {
    this.subscriptions.push({
      eventType,
      callback
    })
  }
}
